import { render, staticRenderFns } from "./CardAutoSwitch.vue?vue&type=template&id=7c54d811&scoped=true&"
import script from "./CardAutoSwitch.vue?vue&type=script&lang=js&"
export * from "./CardAutoSwitch.vue?vue&type=script&lang=js&"
import style0 from "./CardAutoSwitch.vue?vue&type=style&index=0&id=7c54d811&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c54d811",
  null
  
)

export default component.exports